import { type RootState } from '@/store';

export const selectLogosState = (state: RootState) => state?.logos;

export const selectCompetitors = ({ logos: { competitors } }: RootState) =>
  competitors;

export const selectCompetitorsPagination = ({
  logos: { pagination },
}: RootState) => pagination;

export const selectLogoCollection = ({ logos: { collection } }: RootState) =>
  collection;

export const selectLogosLoading = ({ logos }: RootState) => logos?.loading;

export const selectLogosError = ({ logos }: RootState) => logos?.error;

export const selectTeamLogos = ({ logos: { teamLogos } }: RootState) =>
  teamLogos;

export const selectTeamALogo = ({ logos: { teamLogos } }: RootState) =>
  teamLogos.A;

export const selectTeamBLogo = ({ logos: { teamLogos } }: RootState) =>
  teamLogos.B;
